<template>
  <nav v-if="isAuthenticated" class="nav-bottom">
    <div class="nav-container">
      <!-- Home Tab -->
      <router-link to="/" class="nav-tab" :class="{ 'nav-tab-active': activeSection === 'home' }">
        <Home class="nav-tab-icon" />
        <span class="nav-tab-label">{{ t('common.navigation.feed') }}</span>
      </router-link>

      <!-- People Tab -->
      <router-link
        to="/exploring"
        class="nav-tab"
        :class="{ 'nav-tab-active': activeSection === 'people' }"
      >
        <Flame class="nav-tab-icon" />
        <span class="nav-tab-label">{{ t('common.navigation.exploring') }}</span>
      </router-link>

      <!-- Spark Tab (Central FAB) -->
      <button
        class="nav-fab"
        :class="{ 'nav-fab-active': activeSection === 'spark' }"
        @click="$router.push('/spark')"
      >
        <div class="nav-fab-icon">
          <Sparkles class="h-6 w-6" />
        </div>
        <span class="nav-tab-label font-semibold">{{ t('common.navigation.spark') }}</span>
      </button>

      <!-- My Loves Tab -->
      <router-link
        to="/my-loves"
        class="nav-tab"
        :class="{ 'nav-tab-active': activeSection === 'loves' }"
      >
        <Heart class="nav-tab-icon" />
        <span class="nav-tab-label">{{ t('common.navigation.loves') }}</span>
      </router-link>

      <!-- More Tab -->
      <router-link
        to="/more"
        class="nav-tab"
        :class="{ 'nav-tab-active': activeSection === 'more' }"
      >
        <Globe class="nav-tab-icon" />
        <span class="nav-tab-label">{{ t('common.navigation.more') }}</span>
      </router-link>
    </div>
  </nav>
</template>

<script setup>
import { Home, Flame, Sparkles, Heart, Globe } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const { t } = useI18n()
const route = useRoute()

const activeSection = computed(() => {
  const moreRoutes = [
    'more',
    'duonamo',
    'memory-game',
    'seven-facts',
    'personals',
    'my-personals',
    'create-personal',
    'edit-personal',
    'personal-detail',
    'ad-replies',
    'my-replies',
    'privacy-policy',
    'admin'
  ]

  if (route.name === 'home') return 'home'
  if (route.name === 'exploring' || route.name === 'user-profile') return 'people'
  if (route.name === 'spark') return 'spark'
  if (route.name === 'my-loves') return 'loves'
  if (moreRoutes.includes(route.name)) return 'more'
  return ''
})

defineProps({
  isAuthenticated: {
    type: Boolean,
    required: true
  }
})
</script>

<style scoped>
.safe-bottom {
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
